import {
  Star,
  Security,
  LocalHotel,
  Weekend,
  VerifiedUser,
  ThumbUp,
} from "@mui/icons-material";
import { Box, Stack, Typography, Grid } from "@mui/material";
import Header from "../../../components/Header";
import { motion } from "framer-motion";

const Values = () => {
  const values = [
    { title: "Privacy", icon: Security },
    { title: "Hospitality", icon: LocalHotel },
    { title: "Comfort", icon: Weekend },
    { title: "Integrity", icon: VerifiedUser },
    { title: "Satisfaction", icon: ThumbUp },
    { title: "Excellence", icon: Star },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <Box
      maxWidth={1000}
      mx="auto"
      mt={{ xs: 4, sm: 8 }}
      mb={{ xs: 16, sm: 24 }}
      px={2}
    >
      <Box m="auto" width="100%">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Grid container spacing={{ xs: 2, sm: 3 }}>
            {values.map((value, idx) => {
              const IconComponent = value.icon;
              return (
                <Grid item xs={6} sm={6} md={4} key={idx}>
                  <motion.div variants={itemVariants}>
                    <Stack
                      borderRadius={8}
                      overflow="hidden"
                      spacing={{ xs: 2, sm: 4 }}
                      direction={{ xs: "column", sm: "row" }}
                      p={4}
                      back
                      alignItems="center"
                      bgcolor="rgba(255, 255, 255, 0.10)"
                    >
                      <Stack
                        alignItems="center"
                        justifyContent="center"
                        width={64}
                        height={64}
                        border="1px solid #ffffff40"
                        borderRadius={100}
                        boxSizing="border-box"
                        pt={1}
                      >
                        <Box color="accent.main">
                          <IconComponent />
                        </Box>
                      </Stack>
                      <Typography
                        textAlign="center"
                        variant="h6"
                        fontWeight={500}
                      >
                        {value.title}
                      </Typography>
                    </Stack>
                  </motion.div>
                </Grid>
              );
            })}
          </Grid>
        </motion.div>
      </Box>
    </Box>
  );
};

export default Values;
